import { render, staticRenderFns } from "./IconApproved.vue?vue&type=template&id=90f997d2&"
import script from "./IconApproved.vue?vue&type=script&lang=js&"
export * from "./IconApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports